import * as React from 'react';

export interface UnincorporatedAssociationIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * UnincorporatedAssociationIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Unincorporated Association. Three overlapping rings in magenta tones (informal community group).
 */
const UnincorporatedAssociationIcon: React.FunctionComponent<UnincorporatedAssociationIconProps> = ({
  className,
  size = 40,
  title = 'Unincorporated Association',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <circle cx="24" cy="14" r="9" fill="none" stroke="#a8226e" strokeWidth="3.5"/>
      <circle cx="15" cy="30" r="9" fill="none" stroke="#c84285" strokeWidth="3.5"/>
      <circle cx="33" cy="30" r="9" fill="none" stroke="#671343" strokeWidth="3.5"/>
  </svg>
);

export default UnincorporatedAssociationIcon;
